import { render } from "./Risque.vue?vue&type=template&id=f1eacb10"
import script from "./Risque.vue?vue&type=script&lang=js"
export * from "./Risque.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__